<template>
  <div v-if="event" class="w-full flex-wrap flex event-bg">
    <div class="p-3 border-l border-secondary6 border-b w-1/3">
      <h1 class="text-left text-secondary7 text-xs font-light">
        {{ $t('events.fieldsLabels.startDate') }}
      </h1>
      <p v-if="event.date" class="text-blackp text-sm text-left">
        {{ moment.utc(event.date).format('L') }}
      </p>
      <p v-else class="text-blackp text-sm text-left">-</p>
    </div>

    <div class="p-3 border-secondary6 border-b w-1/3">
      <h1 class="text-left text-secondary7 text-xs font-light">
        {{ $t('events.fieldsLabels.delegations') }}
      </h1>

      <p class="text-blackp text-sm text-left">
        {{ event.delegation.name }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
  import {
    CommonCeiling,
    Delegation,
    DelegationSunset
  } from '@/services/api/models'
  import { defineComponent } from 'vue'
  import moment from 'moment'
  export default defineComponent({
    name: 'DelegationSunsetCard',
    props: {
      event: {
        type: Object as () => DelegationSunset | undefined,
        required: true
      }
    },
    setup() {
      return { moment }
    }
  })
</script>

<style lang="scss" scoped>
  .event-bg {
    background: var(--color-contrast-10);
    @apply border border-secondary6 rounded;
  }
</style>
